import types from '../types/reservation'
import {RENT} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import {push} from 'react-router-redux'
import {endpoint as endpointText} from '../../../common/text'
import {ApiError} from '../schemas'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class reservation {

  static setRange(start, end) {
    return {
      type: types.SET_RANGE,
      payload: {
        start,
        end,
      }
    }
  }

  static saveAddItem() {
    return function(dispatch, getState) {

      const state = getState().ui.rent

      const rent = state.orchestrator.get('rent')
      const itemId = state.orchestrator.get('itemId')
      const startDate = state.reservation.get('startDate')
      const endDate = state.reservation.get('endDate')

      if (rent === null || itemId === '' || startDate === null || endDate === null) {
        dispatch(reservation.saveAddItemFail(''))
        return Promise.reject(null)
      }

      dispatch({type: types.SAVE_ADD_ITEM})

      const data = new FormData()
      data.append('object_id', itemId)
      data.append('start_date', startDate.format('X'))
      data.append('end_date', endDate.format('X'))

      return apiPrivate.put(RENT + '/rent/' + rent.get('ID') + '/object', data)
        .then(response => {
          dispatch(reservation.saveAddItemSuccess(startDate, endDate))
          return {startDate, endDate}
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(reservation.saveAddItemFail(message))
              return
            }
            const response = new ApiError(error.response.data)
            console.log(response, error.response.data)
            message = response.description
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(reservation.saveAddItemFail(message))
          dispatch(simpleSnackbarActions.showMessage(message))
        })
    }
  }

  static saveAddItemSuccess(startDate, endDate) {
    return {
      type: types.SAVE_ADD_ITEM_SUCCESS,
      payload: {
        startDate,
        endDate
      },
    }
  }

  static saveAddItemFail(error) {
    return {
      type: types.SAVE_ADD_ITEM_FAIL,
      payload: {
        error,
      },
    }
  }
}



// WEBPACK FOOTER //
// ./src/sections/rent/actions/reservation.js